import { useEffect, useState } from "react";
import { TCustomizationSelection } from "constants/product-customizations/customization-selection.types";

export const usePrintType = (
    selected?: TCustomizationSelection,
): [string, (value: ((prevState: string) => string) | string) => void] => {
    const [printType, setPrintType] = useState("");

    useEffect(() => {
        if (selected?.printType) {
            setPrintType(selected?.printType);
        }
    }, [selected?.printType]);

    return [printType, setPrintType];
};
